function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoosted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 10,
    width: 10,
    style: {
      padding: 2
    },
    id: "Layer_1",
    viewBox: "0 0 712 712",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M95.998,418.909H76.22c-25.706,0-46.545,20.84-46.545,46.545C29.674,491.16,50.514,512,76.22,512  h66.324h188.509c83.413,0,151.273-67.86,151.273-151.273c0-40.609-16.088-77.528-42.22-104.727  c26.132-27.2,42.22-64.118,42.22-104.727C482.326,67.86,414.466,0,331.053,0H142.544H76.22C50.514,0,29.674,20.84,29.674,46.545  s20.84,46.545,46.545,46.545h19.779V256V418.909z M189.089,93.091h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,93.091L189.089,93.091z M189.089,302.545h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,302.545L189.089,302.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M189.089,418.909V302.545H256v-93.091h-66.911V93.091H256V0H142.544H76.22  C50.514,0,29.674,20.84,29.674,46.545s20.84,46.545,46.545,46.545h19.779V256v162.909H76.22c-25.706,0-46.545,20.84-46.545,46.545  C29.674,491.16,50.514,512,76.22,512h66.324H256v-93.091H189.089z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoosted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boosted.f9fa9b50dc54e20faee2fee992b8bf28.svg";